import React, {Component} from "react";
import heroLogo from "../../images/icons/heroLogoWhite.png";
import styled from "styled-components";
import {DistinctSpacer, FlexibleSpacer} from "../Spacer";
import { Link } from 'react-router-dom';
import {ColoredAcionButton, ButtonIcon} from "../button/ActionButton";
import appleIcon from "../../images/icons/appleOrange.png";
import testflight from "../../images/icons/testflight.png";
import {ColoredActionButtonTitle} from "../Fonts";

const Container = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;
  height: 92px;
  padding-right: 40px;
  padding-left: 40px;
  background-color: transparent;

  @media only screen and (max-width: 896px) {
    padding-left: 0;
    padding-right: 0;
    height: 72px;
  }
`;

const LinkContainer = styled(Link)`
  display: flex;
  align-items: center;
  text-decoration: none;
  height: 92px;
`;

const Logo = styled.div<{ icon: string }>`
  width: 28px;
  height: 28px;
  background: url(${props => props.icon}) no-repeat center;
  background-size: 28px;
  margin-top: 0;
  margin-right: 8px;
`;

const Type = styled.span`
  font: 16px "Euclid Circular A", sans-serif;
  font-weight: 600;
  line-height: 24px;
  color: #FAF8F7;

  @media only screen and (max-width: 768px) {
    font: 16px "Euclid Circular A", sans-serif;
    font-weight: 600;
    line-height: 24px;
  }
`;

const Logotype = () => (
  <LinkContainer to="/">
  <Logo icon={heroLogo}/>
<Type>
Zebra
</Type>
</LinkContainer>
);

const Subtitle = styled.span`
  font: 16px "Euclid Circular A", sans-serif;
  font-weight: 500;
  line-height: 24px;
  color: #A39C99;

  @media only screen and (max-width: 768px) {
    font: 16px "Euclid Circular A", sans-serif;
    font-weight: 500;
    line-height: 24px;
  }
`;

class TransparentNavigationHeader extends Component<{ isPreview?: boolean }> {
  //  As the landing pages is static, there is no need to re-render.
  shouldComponentUpdate() {
    return false;
  }

  onTestFlight = () => {
    // @ts-ignore
    window.open("https://testflight.apple.com/join/O8SYBPKU", '_blank').focus();
  }

  onAppStore = () => {
    // @ts-ignore
    window.open("https://apps.apple.com/us/app/zebra-share-talking-photos/id1548469840", '_blank').focus();
  }

  render() {
    const isPreview = this.props.isPreview ?? false;
    let action;
    if (isPreview) {
      action = (
        <div style={{display: "flex"}}>
          <ColoredAcionButton height={44} width={44} onClick={this.onAppStore}>
            <ButtonIcon icon={appleIcon} tint={"#FE6A33"}/>
          </ColoredAcionButton>
        </div>
      )
    } else {
      action = (
        <ColoredAcionButton height={44} width={44} onClick={this.onAppStore}>
          <ButtonIcon icon={appleIcon} tint={"#FE6A33"}/>
        </ColoredAcionButton>
      )
    }
    return (
      <Container>
        <Logotype/>
      <FlexibleSpacer/>
        {action}
    </Container>
  );
  }
}

export default TransparentNavigationHeader;